import React from 'react';
import { Grid } from '@mui/material';

import NewPage from '../components/NewPage';
import RobotStatusContainer from '../containers/robot/RobotStatusContainer';

const RobotPage = () => {
  return (
    <NewPage title="로봇 관리">
      <Grid item xs={12}>
        <RobotStatusContainer />
      </Grid>
    </NewPage>
  );
};

export default RobotPage;
